export default "__VITE_ASSET__CKXjgODk__"